import RoundCleanApp from './RoundCleanApp.vue'
import RoundPatrolInspection from './pages/RoundPatrolInspection.vue'
import RoundTerm from './pages/RoundTerm.vue'
import RoundUnPatrolList from './pages/RoundUnPatrolList.vue'
import RoundScheduleListByStaff from './pages/RoundScheduleListByStaff.vue'
import RoundCheckList from './pages/RoundCheckList.vue'
import RoundDownload from './pages/RoundDownload.vue'
import RoundDownloadTemp from './pages/RoundDownloadTemp.vue'
import RoundSpecialTemp from './pages/RoundSpecialTemp.vue'
import RoundCheckListTable from './pages/RoundCheckListTable.vue'
import RoundSiteListMaster from './pages/RoundSiteListMaster.vue'

export default {
  path: '/RoundClean',
  component: RoundCleanApp,
  children: [
    {
      path: '/RoundPatrolInspection',
      name: 'RoundPatrolInspection',
      component: RoundPatrolInspection,
      meta: { requiresAuth: true, title: 'apollo-RP - 報告書項目設定' },
      props: true
    },
    {
      path: '/RoundTerm',
      name: 'RoundTerm',
      component: RoundTerm,
      meta: { requiresAuth: true, title: 'apollo-RP - 期間設定' },
      props: true
    },
    {
      path: '/RoundUnPatrolList',
      name: 'RoundUnPatrolList',
      component: RoundUnPatrolList,
      meta: { requiresAuth: true, title: 'apollo-RP - 未点検一覧' },
      props: true
    },
    {
      path: '/RoundScheduleListByStaff',
      name: 'RoundScheduleListByStaff',
      component: RoundScheduleListByStaff,
      meta: { requiresAuth: true, title: 'apollo-RP - 予定一覧' },
      props: true
    },
    {
      path: '/RoundCheckList',
      name: 'RoundCheckList',
      component: RoundCheckList,
      meta: { requiresAuth: true, title: 'apollo-RP - 点検一覧' },
      props: true
    },
    {
      path: '/RoundDownload',
      name: 'RoundDownload',
      component: RoundDownload,
      meta: { requiresAuth: true, title: 'apollo-RP - ダウンロード' },
      props: true
    },
    {
      path: '/RoundDownloadTemp',
      name: 'RoundDownloadTemp',
      component: RoundDownloadTemp,
      meta: { isPublic: true, title: 'apollo-RP - template' },
      props: true
    },
    {
      // 特別仕様（清掃前・清掃後）の PDF 用。夜のバッチが puppeteer で開く
      path: '/RoundSpecialTemp',
      name: 'RoundSpecialTemp',
      component: RoundSpecialTemp,
      meta: { isPublic: true, title: 'apollo-RP - template' },
      props: true
    },
    {
      path: '/RoundCheckListTable',
      name: 'RoundCheckListTable',
      component: RoundCheckListTable,
      meta: { requiresAuth: true, title: 'apollo-RP - 点検表' },
      props: true
    },
    {
      path: '/RoundSiteListMaster',
      name: 'RoundSiteListMaster',
      component: RoundSiteListMaster,
      meta: { requiresAuth: true, title: 'apollo-RP - 対象物件マスタ' },
      props: true
    },
  ]
}
